<script>
	import { getContext, onDestroy, onMount } from 'svelte';

	export let title = '';
	export let isActive = undefined;
	export let disabled = false;

	const tabView = getContext('ilb-tab-view');
	const activeIndexStore = tabView?.activeIndex;
	const panelId = `ilb-tab-panel-${Math.random().toString(36).slice(2)}`;
	let pane;
	let unregister;
	let active = false;

	if (!tabView) {
		throw new Error('TabPane must be used inside TabView.');
	}

	$: if (pane) {
		pane.title = title;
		pane.isActive = isActive;
		pane.disabled = disabled;
		tabView.update();
	}

	$: active = pane && $activeIndexStore === pane.index;

	onMount(() => {
		pane = { title, isActive, disabled, panelId };
		unregister = tabView.register(pane);
		tabView.update();
	});

	onDestroy(() => unregister?.());
</script>

<div
	data-ilb-tab-pane
	class="tab-pane"
	class:--active={active}
	role="tabpanel"
	id={panelId}
	aria-hidden={!active}
	hidden={!active}
>
	<slot />
</div>

<style>
	.tab-pane {
		width: 100%;
	}
</style>
